import ImgSlot from '@/ui/ImgSlot';
import type { FeaturedGuest } from '@/types';

import styles from './FeaturedGuestGrid.module.css';

interface FeaturedGuestGridProps {
  guests: readonly FeaturedGuest[];
}

export default function FeaturedGuestGrid({ guests }: FeaturedGuestGridProps) {
  return (
    <div className={styles.grid}>
      {guests.map((g) => {
        const href = g.wikipedia ?? g.ra;
        const linked = Boolean(href);
        const content = (
          <>
            <ImgSlot src={g.portraitUrl} alt={g.name} />
            <div className={styles.info}>
              <span className={styles.name}>{g.name}</span>
              {g.hometown && <span className={styles.meta}>{g.hometown}</span>}
            </div>
          </>
        );

        return href ? (
          <a
            key={g.name}
            href={href}
            target="_blank"
            rel="noreferrer"
            title={g.tagline}
            className={styles.cell}
            data-linked={linked ? 'true' : undefined}
          >
            {content}
          </a>
        ) : (
          <div
            key={g.name}
            className={styles.cell}
            title={g.tagline}
          >
            {content}
          </div>
        );
      })}
    </div>
  );
}
